(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const s_collections = document.querySelectorAll("#us-collection-selector .selector-collection");
    const containerBanner = document.querySelector(".c-hp-video-banner-container");
    const contentWrapperBanner = document.querySelector(".c-hp-video-banner-content-wrapper");
    const bannerContent = document.querySelector(".c-hp-video-banner-content");
    const wrapperCollection = document.querySelector("#us-collection-selector");
    const wrapperMake = document.querySelector("#us-make-selector");
    const wrapperMakeParent = document.querySelector("#us-make-selector-parent");
    const makeContainer = document.querySelector("#us-make-selector");
    const acvWrapper = document.querySelector("#acv-wrapper");
    window.BACK_SVG =         `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg">
          <path d="M401.4 224h-214l83-79.4c11.9-12.5 11.9-32.7 0-45.2s-31.2-12.5-43.2 0L89 233.4c-6 5.8-9 13.7-9 22.4v.4c0 8.7 3 16.6 9 22.4l138.1 134c12 12.5 31.3 12.5 43.2 0 11.9-12.5 11.9-32.7 0-45.2l-83-79.4h214c16.9 0 30.6-14.3 30.6-32 .1-18-13.6-32-30.5-32z"></path>
        </svg>`

    initCollectionSelector();

    function initCollectionSelector() {
      if (!s_collections?.length) return;

      s_collections.forEach((each) => {
        if (each.classList.contains("selector-acv")) {
          each.addEventListener("click", () => {
            toggleVisibility(bannerContent, false);
            toggleVisibility(wrapperCollection, false);
            toggleVisibility(acvWrapper, true);
            containerBanner.classList.add("heightArrange");
            contentWrapperBanner.style.justifyContent = "center";
          });
        } else {
          each.addEventListener("click", () => handleCollectionClick(each));
        }
      });
    }

    function funcBackBtn() {
      const button = document.createElement("button");
      button.className = "goBackBtn";
      button.innerHTML = BACK_SVG;
      return button;
    }

    function handleCollectionClick(element) {
      const title = element.dataset.collectionTitle;
      const id = element.dataset.id;
      const matched = getCollectionByTitle(id);

      if (matched) {
        const sorted = [...matched.products].sort((a, b) => a.model.localeCompare(b.model));
        renderMakes(sorted);
      }

      toggleVisibility(bannerContent, false);
      toggleVisibility(wrapperCollection, false);
      createSelectedColl(title)  
    }


    function createSelectedColl(title){
      const selectedColl = document.createElement("div");
      selectedColl.className = "selectedColl";

      const goBackBtn = funcBackBtn();
      const collTitle = document.createElement("h2");
      collTitle.className = "collTitle";
      collTitle.textContent = title;

      selectedColl.appendChild(goBackBtn);
      selectedColl.appendChild(collTitle);
      wrapperMakeParent.prepend(selectedColl);

      if (goBackBtn) {
        goBackBtn.addEventListener("click", () => {
          selectedColl.remove();
          contentWrapperBanner.classList.remove("make-dark");
          containerBanner.classList.remove("heightArrange");
          toggleVisibility(bannerContent, true);
          toggleVisibility(wrapperCollection, true);
          wrapperMake.innerHTML = "";
        });
      }
    }

    function getCollectionByTitle(id) {
      return window.collectionProductList.find((c) => c.id === id);
    }

    function toggleVisibility(element, isShow) {
      if (element) element.style.display = isShow ? "flex" : "none";
    }

    function createMakeCard(product) {
      const div = document.createElement("div");

      const redirectPP = document.createElement("a");
      redirectPP.className = "us-make-bottom-href";
      redirectPP.href = product.url || "#";
      redirectPP.style.display = "block";

      const img = document.createElement("img");
      img.src = product.second_img || "";
      img.className = "us-make-bottom-img";
      img.alt = product.model;
      img.style.width = "100%";

      const h3 = document.createElement("h3");
      h3.classList.add("us-make-bottom", "us-make-bottom-info");
      

      const modelText = document.createElement("span");
      modelText.textContent = product.model;

      const rating = document.createElement("span");
      rating.className = "loox-rating";
      rating.dataset.id = product.id;
      rating.dataset.rating = product.rating;
      rating.dataset.raters = product.reviews;

      const atcText = document.createElement("h3");
      atcText.classList.add("us-make-bottom", "atcText");


      atcText.textContent = custom_cta.find(each => each.model === product.model)?.text || "Discover Now!";


      h3.appendChild(modelText);
      h3.appendChild(rating);
      redirectPP.appendChild(img);
      redirectPP.appendChild(h3);
      redirectPP.appendChild(atcText);
      div.appendChild(redirectPP);

      redirectPP.addEventListener("click", () => {
        wrapperMakeParent.style.pointerEvents = "none";

        const spinnerHTML = `
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke="#fc3" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        `;

        redirectPP.querySelector(".us-make-bottom").insertAdjacentHTML("beforeend", spinnerHTML);
      });

      return div;
    }

    function renderMakes(products) {
      makeContainer.innerHTML = "";
      contentWrapperBanner.classList.add("make-dark");
      containerBanner.classList.add("heightArrange");

      products.forEach((product, index) => {
        const card = createMakeCard(product);
        card.classList.add("make-card");
        makeContainer.appendChild(card);

        setTimeout(() => {
          card.classList.add("make-show");
        }, index * 100);
      });
    }


  let custom_cta = [
      { "model": "Cadillac Escalade", "text": "Make your luxury beast roar louder" },
      { "model": "Dodge Durango", "text": "Turn family trips into drag races" }
    ]
    




  });

})();



function resetPointerEvents() {
  const wrapper = document.querySelector("#us-make-selector-parent");
  if (wrapper) wrapper.style.pointerEvents = "auto";

  const spinner = document.querySelector("#us-make-selector .loading__spinner");
  if (spinner && spinner.parentNode) {
    spinner.parentNode.removeChild(spinner);
  }
}
window.addEventListener("load", resetPointerEvents);
window.addEventListener("pageshow", (event) => {
  if (event.persisted) resetPointerEvents();
});
